import React, { PropsWithChildren, useCallback, useEffect, useRef, useState } from 'react';
import DataGrid, { Grouping, GroupPanel, Export, Toolbar, Item, SearchPanel, HeaderFilter, FilterRow, Column, Editing, Form, Lookup, MasterDetail, ValidationRule, RequiredRule } from "devextreme-react/data-grid";
import { useAuthStore } from '../hooks/useAuthStore';
import CommonLicenceDataGrid, { IMyDataGridOptions } from './CommonLicenceDataGrid';

import 'jspdf-autotable';
import ExporterToPdf from '../utils/ExporterToPdf';
import ExporterToExcel from '../utils/ExporterToExcel';
import { isMobileDevice } from "../utils/DeviceDetect";

export interface IReportDataGridOptions extends IMyDataGridOptions {
    reportName?: any;
    dataStore?: any;
    runDate?: any;
}


const ReportGrid: React.FC<PropsWithChildren<IReportDataGridOptions>> = ({ reportName, dataStore, runDate, ...props }) => {
//const ReportGrid = ({ reportName, reportObject, dataStore, runDate }) => {
//    const authStore = useAuthStore();
    const exportFormats = ['xlsx', 'pdf'];

    const onExporting = (e) => {
        if (e.format == 'xlsx') {
            ExporterToExcel.exportToExcel(reportName, [e.component]);
        }
        else if (e.format == 'pdf') {
            ExporterToPdf.exportToPdf(reportName, [e.component]);
        }
    }


//    return <AppTest keyExpr="Id" dataStore={dataStore} columns={props.columns || props.defaultColumns} />
    return (
        <CommonLicenceDataGrid
            keyExpr="Id"
            visible={true}
            licenceStore={dataStore}
            //            innerRef={dataGridRef}
            allowColumnReordering={isMobileDevice ? false : true}
            searchPanel={{ visible: true }}
            onExporting={onExporting}
            {...props}
        >
            <FilterRow visible={false} />
            <HeaderFilter visible={true} />
            <Export
                enabled={true}
                formats={exportFormats}                
//                fileName={reportName}
                allowExportSelectedData={false}
            />
            <GroupPanel
                visible={true}
                allowColumnDragging={isMobileDevice ? false : true}
            />
            {props.children}
        </CommonLicenceDataGrid >
    );
}


export default React.memo(ReportGrid);

